// src/hooks/useAuth.js
import { useContext, useMemo } from "react";
import AuthContext from "../context/AuthContext";

export default function useAuth() {
  const ctx = useContext(AuthContext);

  return useMemo(() => {
    if (ctx && typeof ctx === "object") {
      // ensure minimal API surface
      return {
        getAuthToken: ctx.getAuthToken ?? (() => localStorage.getItem("authToken") || ""),
        getMerchantId: ctx.getMerchantId ?? (() => localStorage.getItem("merchantId") || ""),
        getParentClientId: ctx.getParentClientId ?? (() => localStorage.getItem("parentClientId") || ""),
        login: ctx.login ?? ((token, extra = {}) => {
          if (token) localStorage.setItem("authToken", token);
          if (extra.merchantId) localStorage.setItem("merchantId", extra.merchantId);
          if (extra.parentClientId) localStorage.setItem("parentClientId", extra.parentClientId);
        }),
        logout: ctx.logout ?? (() => {
          localStorage.removeItem("authToken");
          localStorage.removeItem("merchantId");
          localStorage.removeItem("parentClientId");
        }),
        isAuthenticated: ctx.isAuthenticated ?? (() => !!localStorage.getItem("authToken")),
      };
    }

    // fallback implementation using localStorage (works in all environments)
    return {
      getAuthToken: () => localStorage.getItem("authToken") || "",
      getMerchantId: () => localStorage.getItem("merchantId") || localStorage.getItem("parentClientId") || "",
      getParentClientId: () => localStorage.getItem("parentClientId") || "",
      login: (token, extra = {}) => {
        if (token) localStorage.setItem("authToken", token);
        if (extra.merchantId) localStorage.setItem("merchantId", extra.merchantId);
        if (extra.parentClientId) localStorage.setItem("parentClientId", extra.parentClientId);
      },
      logout: () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("merchantId");
        localStorage.removeItem("parentClientId");
      },
      isAuthenticated: () => !!localStorage.getItem("authToken"),
    };
  }, [ctx]);
}
